module.exports = " <p class=vux-divider> <slot></slot> </p> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/divider/index.vue
// module id = 221
// module chunks = 2